import { Text } from '@simplywallst/ui-core';

import ChartWrapper from '@/pages/CompanyReport/components/Overview/components/ChartWrapper';
import { PillWrapper } from './styled';
import { SankeyContainer } from './components/Sankey';
import Pill from '@/components/Pill';
import CompanyReportFeedbackBar from '@/components/CompanyReportFeedbackBar';
import ReportSubSection from '@/components/ReportSubSection';

interface Props {
  companyName: string;
}

export function ExtendedIncomeStatement({ companyName }: Props) {
  return (
    <>
      <CompanyReportFeedbackBar typeFormId="LtbY09Hp" />
      <ReportSubSection
        title={
          <>
            Revenue & Expenses Breakdown
            <PillWrapper>
              <Text as="span" typography="tiny">
                <Pill intent="info">Beta</Pill>
              </Text>
            </PillWrapper>
          </>
        }
        description={`How ${companyName} makes and spends money. Based on latest reported
              earnings, on an LTM basis.`}
        trackingProps={{ subject: 'chart' }}
        bodyRender={() => (
          <ChartWrapper
            id="extended-income-statement"
            chart={<SankeyContainer />}
            preRenderHeight={500}
            actionsMarginTop={16}
            feedbackLabel="Revenue & Expenses Breakdown"
          />
        )}
      />
      <hr />
    </>
  );
}
